/* AVEA: Quick-Add im Warenkorb-Drawer + Groessenwechsel in der Zeile.
   Delegierte Listener, damit sie ein Neu-Rendern des Drawers ueberleben.
   Gerendert wird wie im Theme selbst: nur der Inhalt von .drawer__inner wird
   ersetzt, aus der sections-Antwort von /cart/add.js bzw. /cart/change.js.

   Zusaetzlich: Judge.me haengt sein Bewertungs-Widget (#jdgm-cart-drawer-widget)
   von sich aus in .cart-drawer__empty-content, also UEBER die Quick-Add-Reihe.
   Wir schieben es ans Ende von .drawer__inner-empty, damit erst der Upsell
   kommt und dann die Bewertungen. */
(function () {
  if (window.__aveaCartInit) return;
  window.__aveaCartInit = true;

  var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function moveReviewsBelowUpsell() {
    try {
      var w = document.querySelector('cart-drawer #jdgm-cart-drawer-widget, cart-drawer .jdgm-review-widget');
      if (!w) return;
      var empty = document.querySelector('cart-drawer .drawer__inner-empty');
      if (!empty) return;
      if (w.parentElement === empty && w === empty.lastElementChild) return;
      empty.appendChild(w);
      w.style.marginTop = '8px';
    } catch (e) {}
  }

  function watchReviews() {
    moveReviewsBelowUpsell();
    var root = document.querySelector('cart-drawer');
    if (!root || root.dataset.aveaJdgmWatch) return;
    root.dataset.aveaJdgmWatch = '1';
    var mo = new MutationObserver(function () { moveReviewsBelowUpsell(); });
    mo.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchReviews);
  } else {
    watchReviews();
  }
  window.addEventListener('load', watchReviews);

  function renderDrawer(res) {
    try {
      var html = res && res.sections && res.sections['cart-drawer'];
      if (!html) { window.location.reload(); return; }
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
      var target = document.querySelector('.drawer__inner');
      if (!fresh || !target) { window.location.reload(); return; }
      target.innerHTML = fresh.innerHTML;
      target.classList.remove('is-empty');
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.classList.add('animate', 'active');
        var overlay = document.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', function () { drawer.close(); });
        }
      }
      document.body.classList.add('overflow-hidden');
      moveReviewsBelowUpsell();
    } catch (e) {
      window.location.reload();
    }
  }

  function post(url, payload) {
    payload.sections = 'cart-drawer';
    payload.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: H, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.avea-add') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var label = btn.textContent;
    btn.disabled = true;
    post('/cart/add.js', { items: [{ id: btn.getAttribute('data-vid'), quantity: 1 }] })
      .then(function (res) {
        if (res && res.status && res.status !== 200) { throw new Error(res.description || 'add'); }
        renderDrawer(res);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('avea-size')) return;
    var line = parseInt(sel.getAttribute('data-line'), 10);
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    var newId = sel.value;
    sel.disabled = true;
    post('/cart/change.js', { line: line, quantity: 0 })
      .then(function () { return post('/cart/add.js', { items: [{ id: newId, quantity: qty }] }); })
      .then(function (res) { renderDrawer(res); })
      .catch(function () { sel.disabled = false; });
  });
})();
